/* eslint-disable  */

// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { tax } from "../../../../api/Api";

export const getAllTax = createAsyncThunk("appTax/getAllTax", async () => {
  try {
    return tax.getAll();
  } catch (error) {
    console.error(error);
  }
});

export const getTax = createAsyncThunk("appTax/getTax", async (id) => {
  try {
    return tax.getTax(id);
  } catch (error) {
    console.error(error);
  }
});

export const addTax = createAsyncThunk("appTax/addTax", async (values) => {
  try {
    return tax.create(values);
  } catch (error) {
    console.error(error);
  }
});

export const deleteTax = createAsyncThunk("appTax/deleteTax", async (id) => {
  return tax.deleteItem(id);
});

export const editTax = createAsyncThunk("appTax/editTax", async (values) => {
  return tax.edit(values);
});

export const appTaxSlice = createSlice({
  name: "appTax",
  initialState: {
    tax: [],
    isFetchedTax: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllTax.fulfilled, (state, action) => {
        state.tax = action.payload?.data?.data;
        state.isFetchedTax = true;
      })
      .addCase(deleteTax.fulfilled, (state, action) => {
        state.isFetchedTax = false;
      })
      .addCase(editTax.fulfilled, (state, action) => {
        state.isFetchedTax = false;
      })
      .addCase(addTax.fulfilled, (state, action) => {
        state.isFetchedTax = false;
      });
  },
});

export default appTaxSlice.reducer;
